/**
 * ResponsavelSaraivaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelSaraiva} from '@/model/resource/ResponsavelSaraiva'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelSaraivaCollection extends PageCollection<
  ResponsavelSaraiva
> {
  constructor() {
    super(ResponsavelSaraiva)
  }

  queryAsPage() {
    return this.listResponsavelSaraiva()
  }

  async listResponsavelSaraiva() {
    return await Request.get(`/admin/responsavel-saraiva`, {
      params: this.params,
    })
      .name('listResponsavelSaraiva')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelSaraiva() {
    return await Request.get(`/admin/responsavel-saraiva/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelSaraiva')
      .as(this)
      .getResponse()
  }
}
